import { useRef } from 'react'

const TickerScroller = ({ messages }: any) => {
  const scrollerRef = useRef(null)

  // Duplicate messages to ensure seamless loop
  const fullMessageList = [...messages, ...messages]

  return (
    <div className='ticker-container'>
      <div className='ticker-content' ref={scrollerRef}>
        {fullMessageList.map((msg: any, index: number) => (
          <span className='ticker-item' key={index}>
            {msg.message}
          </span>
        ))}
      </div>
    </div>
  )
}

export default TickerScroller
